<template>
  <div class="scenes home">
    <Intro/>
    <Music/>
    <Shows/>
    <History/>
    <section class="band bandphoto bandphoto3"></section>
    <Mailinglist/>
    <section class="band bandphoto bandphoto1"></section>
    <Contact/>
  </div>
</template>

<script>
// @ is an alias to /src
import Intro from '@/components/Intro.vue';
import Music from '@/components/Music.vue';
import Shows from '@/components/Shows.vue';
import History from '@/components/History.vue';
import Mailinglist from '@/components/Mailinglist.vue';
import Contact from '@/components/Contact.vue';

export default {
  name: 'home',
  components: {
    Intro,
    Music,
    Shows,
    History,
    Mailinglist,
    Contact,
  },
};
</script>
